import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { askForDecisionAnalytics } from '../../../decision/decisionUtils';
import {
  NavUserDropdownHyperlink,
  NavUserDropdownLink,
} from './NavUserDropdownLink';

export const NavUserDecision: FC = () => (
  <>
    <li>
      <NavUserDropdownHyperlink
        href="/getdecision?source=nav_dropdown"
        target="_blank"
        onClick={askForDecisionAnalytics('ask_decision')}
      >
        <FormattedMessage id="navigation/user/components/NavUserDecision.tsx/1" />
      </NavUserDropdownHyperlink>
    </li>
    <li>
      <NavUserDropdownLink to="/j/envoi?source=nav_dropdown">
        <FormattedMessage id="navigation/user/components/NavUserDecision.tsx/2" />
      </NavUserDropdownLink>
    </li>
  </>
);
